export const ko = {
  meta: {
    title: 'AuthFlow™ - JWT 토큰 기반의 간단한 이메일/비밀번호 인증',
    description: '최신 웹 애플리케이션을 위한 JWT 토큰 기반의 신뢰할 수 있는 이메일/비밀번호 인증. 복잡한 플랫폼과 달리 개발자가 믿고 쓸 수 있는 안전하고 간단한 로그인에 집중합니다.',
  },
	nav: {
		home: '홈',
		features: '기능',
		pricing: '요금',
		compare: '비교',
		contact: '문의',
		getStarted: '시작하기',
		signIn: '로그인',
	},
	hero: {
		badge: '전 세계 DevSecOps 팀이 신뢰',
		title: '인증',
		subtitle: '제대로',
		description: '가장 빠르고 안전한 이메일/비밀번호 인증. 복잡한 플랫폼 대신 핵심에 집중합니다: 바로 동작하는 안전한 JWT 인증.',
		startTrial: '무료 체험 시작',
		getStarted: '시작하기',
			trialNote: '신용카드 불필요 • 10 월간 활성 사용자 무료',
		metrics: {
			firstIntegrationValue: '5분',
			firstIntegrationLabel: '첫 통합까지',
			predictableSessionsValue: 'JWT',
			predictableSessionsLabel: '예측 가능한 세션',
			noMazeValue: '복잡함 없음',
			noMazeLabel: '인증이 그냥 잘 동작하길 원하는 팀을 위해',
		},
		missionControlLabel: '인증 관제',
		missionControlTitle: '미로 없는 사용자 인증',
		missionControlStatus: '안정',
		sessionLayer: '세션 레이어',
		emailPasswordSignIn: '이메일/비밀번호 로그인',
		roleAwareVerification: '역할 기반 검증',
		validated: '검증됨',
		live: '운영중',
		integrationShapeLabel: '통합 형태',
		integrationShapeValue: '작은 API, 명확한 흐름',
		forTeamsLabel: '대상 팀',
		forTeamsValue: 'IAM 프로젝트 대신 제품 개발에 집중',
	},
	cta: {
		title: '신뢰할 수 있는 인증을 도입할 준비가 되었나요?',
		description: 'JWT 기반 이메일/비밀번호 인증을 선택한 팀에 합류하세요. 지금 무료 체험을 시작하세요.',
		startTrial: '무료 체험 시작',
	},
	dashboard: {
		title: '대시보드',
		users: '사용자',
		activity: '활동',
		settings: '설정',
		logout: '로그아웃',
		profileSettings: '프로필 설정',
		activityLog: '활동 로그',
		welcome: '대시보드에 오신 것을 환영합니다',
		welcomeBack: '다시 오신 것을 환영합니다, {name}. 인증 서비스의 현재 상태를 확인하세요.',
		totalUsers: '총 사용자',
		activeUsers: '활성 사용자',
		totalLogins: '총 로그인',
		recentActivity: '최근 활동',
		noRecentActivity: '최근 활동이 없습니다',
		userSettings: '사용자 설정',
		organizationOwnerCannotBeManaged: '조직 소유자는 관리할 수 없습니다',
		configureSettings: '설정 구성',
		hereIsWhatsHappening: '인증 서비스의 현재 현황입니다.',
		fromLastMonth: '지난달 대비',
		monthlyLogins: '월간 로그인',
		successRate: '성공률',
		latestAuthEvents: '최신 인증 이벤트 및 시스템 업데이트',
		viewAllActivity: '모든 활동 보기',
		userManagement: '사용자 관리',
		manageApplicationUsers: '애플리케이션 사용자를 관리하세요',
		viewAllUsers: '모든 사용자 보기',
		apiKeys: 'API 키',
		manageApiKeys: '인증 API 키 관리',
		systemStatus: '시스템 상태',
		authenticationApi: '인증 API',
		operational: '정상 운영',
		userManagementService: '사용자 관리',
		searchUsers: '사용자 검색...',
		all: '전체',
		active: '활성',
		inactive: '비활성',
		lastLogin: '마지막 로그인',
		never: '없음',
		admin: '관리자',
		owner: '소유자',
		noUsersFound: '조건에 맞는 사용자가 없습니다',
		noUsers: '사용자가 없습니다',
		for: '대상',
		noApiKeyFound: 'API 키를 찾을 수 없습니다',
		hideApiKey: 'API 키 숨기기',
		showApiKey: 'API 키 보기',
		created: '생성됨',
		success: '성공',
		warning: '경고',
		info: '정보',
		system: '시스템',
		justNow: '방금 전',
		minutesAgo: '분 전',
		hoursAgo: '시간 전',
		daysAgo: '일 전',
		notifications: '알림',
		billingReminder: '결제 알림',
		noNewNotifications: '새 알림이 없습니다',
		logOut: '로그아웃',
	},
	about: {
		title: 'AuthFlow™ 소개 - 간단한 이메일/비밀번호 인증 전문가',
		description: 'AuthFlow™의 미션과 비전을 확인하세요. 2023년 설립 이후 JWT 기반 이메일/비밀번호 인증을 더 간단하게 만들고 있습니다.',
		keywords: ['이메일 비밀번호 인증', 'JWT 인증 회사', '인증 전문가', '간단한 인증', '보안 로그인 회사', '개발자 인증', '신뢰 가능한 인증', '토큰 기반 인증', '웹 앱 보안', '인증 플랫폼'],
		ogTitle: 'AuthFlow™ 소개 - 간단한 이메일/비밀번호 인증 전문가',
		ogDescription: '복잡한 플랫폼 대신, 실제로 잘 동작하는 인증에 집중하는 AuthFlow™의 미션을 확인하세요.',
		hero: {
			badge: '2023년 설립',
			title: '우리는',
			titleAccent: '간단한 인증의 미래를 만듭니다',
			description: '모든 개발자가 JWT 기반 이메일/비밀번호 인증을 쉽게 도입할 수 있도록 합니다.',
		},
		mission: {
			title: '우리의 미션',
			description1: '구현과 운영이 쉬운 안전한 토큰 기반 인증을 누구나 사용할 수 있게 합니다.',
			description2: '개인정보 보호와 규정 준수를 기본 설계 원칙으로 삼습니다.',
			description3: '개발자가 제품 개발에 집중하도록 복잡한 인증 문제를 단순화합니다.',
		},
		vision: {
			title: '우리의 비전',
			description1: '인증이 간단하고 신뢰 가능한 세상.',
			description2: '개발자가 신뢰할 수 있는 안전하고 단순한 로그인 인프라를 구축합니다.',
		},
		values: {
			title: '우리의 가치',
			subtitle: 'AuthFlow™의 모든 의사결정을 이끄는 원칙.',
			reliableSecurity: { title: '신뢰 가능한 보안', description: '검증된 보안 모범 사례를 불필요한 복잡함 없이 제공합니다.' },
			developerFirst: { title: '개발자 우선 API', description: '직관적이고 문서가 잘 갖춰진 도구로 뛰어난 개발자 경험을 제공합니다.' },
			communityDriven: { title: '커뮤니티 중심', description: '실제 개발자 요구와 피드백을 기반으로 로드맵을 만듭니다.' },
		},
		team: {
			title: '팀 소개',
			subtitle: '인증의 미래를 만드는 열정적인 사람들.',
			alex: { initials: 'AJ', name: 'Alex Johnson', role: 'CEO & Co-Founder', bio: '대형 글로벌 금융기관 출신 DevSecOps 전문가.' },
			sarah: { initials: 'SC', name: 'Sarah Chen', role: 'CTO & Co-Founder', bio: '10년 이상 인증 시스템을 설계한 풀스택 아키텍트.' },
			marcus: { initials: 'MR', name: 'Marcus Rodriguez', role: 'Head of Product', bio: '개발자 경험 중심의 제품 리더.' },
		},
		stats: {
			title: '숫자로 보는 AuthFlow™',
			developers: '신뢰하는 개발자',
			authentications: '월간 인증 수',
			uptime: '가동률',
			monitoring: '보안 모니터링',
		},
		cta: { title: '우리의 미션에 함께하세요', description: '인증 혁신에 함께할 준비가 되었나요?', getStarted: '무료로 시작하기', contactUs: '문의하기' },
		breadcrumb: { company: '회사', aboutUs: '소개' },
	},
	getStarted: {
		title: 'AuthFlow™ 시작하기 - 이메일/비밀번호 인증 설정 가이드 | JWT API 통합',
		description: 'AuthFlow™로 이메일/비밀번호 인증을 구현하는 완전한 가이드입니다. 몇 분 안에 JWT 기반 보안 로그인을 구성하세요.',
		keywords: ['인증 설정', '이메일 비밀번호 인증', 'JWT 통합', '보안 로그인 가이드', '개발자 인증', 'API 인증 튜토리얼', '토큰 기반 인증', '인증 API 가이드'],
		ogTitle: 'AuthFlow™ 시작하기 - 이메일/비밀번호 인증 설정 가이드 | JWT API 통합',
		ogDescription: 'AuthFlow™로 이메일/비밀번호 인증을 구현하고 JWT 기반 보안 로그인을 몇 분 안에 구성하세요.',
		breadcrumb: { resources: '리소스', getStarted: '시작하기' },
		hero: {
			badge: '빠른 설정 가이드',
			title: '이렇게 시작하세요',
			titleAccent: '이메일/비밀번호 인증',
			description: '우리 플랫폼의 JWT 인증을 이용해 몇 분 안에 앱에 안전한 이메일/비밀번호 로그인을 추가하세요.',
			createAccount: '무료 계정 만들기',
		},
		steps: {
			title: '안전한 이메일/비밀번호 인증을 위한 3단계',
			subtitle: 'AuthFlow™ 엔드포인트를 백엔드에 통합하세요.',
			step1: {
				title: '계정 생성',
				description: 'AuthFlow™에 가입하고 첫 프로젝트를 생성하세요. 서버 측 API 키를 즉시 발급받을 수 있습니다.',
				signUp: '무료 가입',
				viewDemo: '데모 보기',
			},
			step2: {
				title: 'Auth 엔드포인트 통합',
				description: '백엔드에서 /auth 엔드포인트를 사용해 사용자 인증을 처리하세요.',
				features: {
					apiKeyRequired: 'API 키 필요',
					apiKeyDescription: '모든 /auth 엔드포인트는 JWT 토큰 내 조직 API 키를 필요로 합니다.',
					backendIntegration: '백엔드 통합',
					backendDescription: '서버 코드에서만 호출하고 프런트엔드에 API 키를 노출하지 마세요.',
					sessionManagement: '세션 관리',
					sessionDescription: '조직 API 키를 포함한 JWT로 안정적인 사용자 세션을 관리하세요.',
				},
			},
			step3: {
				title: '인증 적용',
				description: '앱을 provider로 감싸고 인증 컴포넌트를 연결하세요.',
				quickStart: '빠른 시작',
				fullDocumentation: '전체 문서',
			},
		},
		apiDocs: {
			title: '/auth API 엔드포인트 기술 가이드',
			subtitle: 'AuthFlow™ 이메일/비밀번호 인증 엔드포인트를 백엔드에 통합하기 위한 완전한 기술 문서입니다.',
			endpoints: {
				foobar: {
					description: '인증 흐름용 임시 anti-abuse 토큰 생성',
					params: '파라미터:',
					identityParam: 'identity (string): 사용자 이메일 주소',
					response: '응답:',
					example: 'Node.js 예시:',
				},
				signUp: {
					description: '조직 내 신규 사용자 계정 생성',
					params: '파라미터:',
					foobarParam: 'foobar (string): /auth/fooBar에서 받은 토큰',
					apiKeyParam: 'api_key (string): 조직 API 키',
					emailParam: 'email (string): 사용자 이메일 주소',
					passwordParam: 'password (string): 사용자 비밀번호 (8-32자, 대문자/소문자/숫자/특수문자 포함)',
					fullnameParam: 'fullname (string): 사용자 전체 이름',
					disclaimedParam: 'disclaimed (string): 반드시 "true"',
					response: '응답:',
					example: 'Node.js 예시:',
				},
				login: {
					description: '사용자를 인증하고 세션 토큰 발급',
					params: '파라미터:',
					foobarParam: 'foobar (string): /auth/fooBar에서 받은 토큰',
					emailParam: 'email (string): 사용자 이메일 주소',
					passwordParam: 'password (string): 사용자 비밀번호',
					apiKeyParam: 'api_key (string): Organization API key',
					response: '응답:',
					tokenNote: '반환된 JWT에는 인증된 사용자 컨텍스트가 포함됩니다',
					example: 'Node.js 예시:',
				},
				validate: {
					description: '사용자 세션 토큰 검증 및 인증 상태 확인',
					params: '파라미터:',
					sessionTokenParam: 'sessionToken (string): /auth/login에서 발급된 JWT',
					emailParam: 'email (string): 사용자 이메일 주소',
					response: '응답:',
					example: 'Node.js 예시:',
				},
				changePassword: {
					description: '인증된 사용자의 비밀번호 변경',
					params: '파라미터:',
					sessionTokenParam: 'sessionToken (string): /auth/login에서 발급된 JWT',
					emailParam: 'email (string): 사용자 이메일 주소',
					newPasswordParam: 'newPassword (string): 새 비밀번호 (동일 복잡도 규칙)',
					response: '응답:',
					example: 'Node.js 예시:',
				},
				logout: {
					description: '사용자 세션을 안전하게 종료',
					params: '파라미터:',
					sessionTokenParam: 'sessionToken (string): /auth/login에서 발급된 JWT',
					emailParam: 'email (string): 사용자 이메일 주소',
					response: '응답:',
					example: 'Node.js 예시:',
				},
			},
			apiKeySetup: {
				title: 'API 키 설정',
				description: '조직 API 키는 /auth 엔드포인트용 JWT에 포함됩니다. 백엔드 환경 변수에 안전하게 저장하세요.',
				envVars: '# 환경 변수',
				securityNote: '보안 주의: 프런트엔드 코드나 브라우저 JavaScript에 API 키를 절대 노출하지 마세요. 모든 /auth 호출은 백엔드 서버에서 수행해야 합니다.',
			},
			implementation: {
				title: '완전한 백엔드 통합 예시',
				notes: '구현 노트:',
				note1: '세션 토큰은 안전하게 저장하세요 (HTTP-only 쿠키 권장)',
				note2: '보호 라우트 처리 전 세션을 검증하세요',
				note3: '토큰 만료와 갱신 로직을 처리하세요',
				note4: '보안 모니터링을 위해 인증 이벤트를 로깅하세요',
			},
			errorHandling: {
				title: '오류 처리 및 보안',
				statusCodes: '주요 HTTP 상태 코드:',
				status200: '200: 성공',
				status400: '400: 잘못된 요청 (필수 파라미터 누락/오류)',
				status401: '401: 인증 실패 (잘못된 토큰, API 키 오류 등)',
				status404: '404: 사용자를 찾을 수 없음',
				status409: '409: 조직이 이미 존재함 (가입)',
				status500: '500: 서버 오류',
				securityPractices: '보안 모범 사례:',
				practice1: '요청 처리 전 JWT를 항상 검증하세요',
				practice2: '모든 API 호출에 HTTPS를 사용하세요',
				practice3: '인증 엔드포인트에 rate limiting을 적용하세요',
				practice4: '세션 토큰은 HTTP-only 보안 쿠키에 저장하세요',
				practice5: '보안 모니터링을 위해 모든 인증 시도를 로깅하세요',
				practice6: '비밀번호/API 키 같은 민감 정보는 로그에 남기지 마세요',
				criticalNote: '중요: 모든 /auth 엔드포인트는 반드시 백엔드 서버에서만 호출해야 합니다. 클라이언트 코드에서 API 키를 노출하면 조직 보안이 손상됩니다.',
			},
		},
		features: { title: '이메일/비밀번호 인증으로 바로 얻는 기능', subtitle: '엔드포인트만 연결하면, 안정적인 JWT 세션은 우리가 제공합니다.' },
		cta: { title: '신뢰 가능한 이메일/비밀번호 인증을 추가할 준비가 되었나요?', description: '오늘 무료 체험을 시작하고 하루 안에 JWT 인증을 도입하세요.', createAccount: '무료 계정 만들기', talkToSales: '영업 문의' },
		parameters: '파라미터',
		response: '응답',
		example: '예시',
		runFailureScenario: '실패 시나리오로 실행',
		failureScenarioOn: '실패 시나리오: 켜짐',
		running: '실행 중...',
		runCurlConsole: '콘솔에서 cURL 실행',
		copied: '복사됨!',
		copyCurl: 'curl 복사',
		copyBackendExample: '백엔드 코드 복사',
		required: '필수',
		optional: '선택',
		consoleRunning: '콘솔 실행 중...',
		consoleDemoTitle: '리눅스 콘솔 데모',
		consoleShellLabel: 'bash -- AuthFlow™ 콘솔',
		notesTitle: '노트',
		endpointContent: {
			session: {
				fooBar: {
					summary: '가입/로그인 전에 짧은 수명의 anti-abuse 토큰을 생성합니다.',
					params: {
						identity: '인증 사용자 이메일 주소',
						apiKey: 'AuthFlow™ 오너 대시보드의 조직 API 키',
						role: '임시 토큰에 인코딩할 RBAC 역할 (기본값: user)',
					},
					notes: {
						expires: '이 토큰은 45초 후 만료됩니다.',
						freshToken: '가입/로그인 직전에 항상 새로운 fooBar 토큰을 발급받으세요.',
					},
				},
				signUp: {
					summary: '오너 조직 내부에 신규 인증 사용자를 생성합니다.',
					params: {
						foobar: '/auth/fooBar에서 반환된 임시 anti-abuse 토큰',
						email: '사용자 이메일 주소',
						password: '{passwordRule} 규칙을 만족하는 비밀번호',
						fullname: '인증 사용자 전체 이름',
						role: '애플리케이션 내부 RBAC 역할',
						apiKey: '조직 API 키',
						disclaimed: '사용자 레코드에 저장되는 불리언 유사 값 (컬렉션 기본값: true)',
					},
					notes: {
						successToken: '가입 성공 시 즉시 세션 토큰이 반환됩니다.',
						duplicateRole: '동일 이메일+역할이 이미 존재하면 409 응답이 반환됩니다.',
					},
				},
				login: {
					summary: '인증 사용자를 로그인하고 세션 토큰 또는 2FA 챌린지를 반환합니다.',
					params: {
						foobar: '/auth/fooBar에서 반환된 임시 anti-abuse 토큰',
						email: '사용자 이메일 주소',
						password: '사용자 비밀번호',
						apiKey: '조직 API 키',
						role: 'RBAC 로그인에 사용할 사용자 역할',
					},
					notes: {
						tempTokenInsteadOfToken: '2FA가 활성화된 경우 token 대신 tempToken이 반환됩니다.',
						exchangeThrough2fa: 'tempToken은 /auth/2fa 검증 엔드포인트 중 하나에서 교환해야 합니다.',
					},
				},
				validate: {
					summary: '인증 사용자의 세션 토큰을 검증합니다.',
					params: {
						sessionToken: 'RS512 JWT 세션 토큰',
						email: '사용자 이메일 주소',
					},
				},
				me: {
					summary: '유효한 세션 기준 현재 인증 사용자 프로필을 조회합니다.',
					params: {
						sessionToken: 'RS512 JWT 세션 토큰',
					},
				},
				logout: {
					summary: '현재 인증 사용자를 로그아웃합니다.',
					params: {
						sessionToken: 'RS512 JWT 세션 토큰',
						email: '사용자 이메일 주소',
					},
				},
			},
			passwordManagement: {
				forgotPassword: {
					summary: '인증 사용자 비밀번호 재설정 이메일을 요청합니다 (열거 공격 방어 응답).',
					params: {
						email: '인증 사용자 이메일 주소',
						apiKey: '조직 API 키',
						role: '인증 사용자 역할 (기본값: user)',
					},
				},
				resetPassword: {
					summary: '유효한 재설정 토큰으로 비밀번호를 변경합니다.',
					params: {
						token: '이메일 링크의 비밀번호 재설정 토큰',
						newPassword: '{passwordRule} 규칙을 만족하는 새 비밀번호',
					},
				},
				changePassword: {
					summary: '로그인된 인증 사용자의 비밀번호를 변경합니다.',
					params: {
						sessionToken: '현재 RS512 JWT 세션 토큰',
						email: '세션 토큰에 인코딩된 이메일',
						oldPassword: '확인을 위한 현재 비밀번호',
						newPassword: '{passwordRule} 규칙을 만족하는 새 비밀번호',
					},
				},
			},
			emailVerification: {
				verifyEmail: {
					summary: 'AuthFlow™ 이메일로 전달된 토큰으로 인증 사용자 이메일을 검증합니다.',
					params: {
						token: '이메일 검증 링크의 검증 토큰',
					},
					notes: {
						openedFromEmail: '이 엔드포인트는 보통 이메일 검증 링크를 클릭해 열립니다.',
						frontendHostedProxy: 'AuthFlow™는 /verify-email 프런트엔드 호스팅 프록시도 지원합니다.',
					},
				},
				resendVerifyEmail: {
					summary: '아직 검증되지 않은 계정에 검증 이메일을 재전송합니다.',
					params: {
						foobar: '/auth/fooBar에서 반환된 임시 토큰',
						email: '인증 사용자 이메일 주소',
						apiKey: '조직 API 키',
						role: '인증 사용자 역할 (기본값: user)',
					},
				},
			},
			twoFactor: {
				enable: {
					summary: '인증 사용자를 위한 TOTP 시크릿과 QR 코드를 생성합니다.',
					params: {
						sessionToken: '현재 세션 토큰',
						email: '인증 사용자 이메일',
						apiKey: '조직 UUID',
						role: '인증 사용자 역할',
					},
				},
				verifySetup: {
					summary: '초기 TOTP 코드를 검증하여 2FA를 활성화합니다.',
					params: {
						sessionToken: '현재 세션 토큰',
						email: '인증 사용자 이메일',
						apiKey: '조직 UUID',
						role: '인증 사용자 역할',
						totpCode: '인증 앱의 6자리 코드',
						secret: '/auth/2fa/enable에서 반환된 TOTP 시크릿',
					},
				},
				disable: {
					summary: '인증 사용자의 TOTP 2FA를 비활성화합니다.',
					params: {
						sessionToken: '현재 세션 토큰',
						email: '인증 사용자 이메일',
						apiKey: '조직 UUID',
						role: '인증 사용자 역할',
						password: '현재 비밀번호',
					},
				},
				verify2fa: {
					summary: '로그인 tempToken과 TOTP 코드로 세션 토큰을 발급받습니다.',
					params: {
						tempToken: '2FA 활성화 로그인 시 /auth/login이 반환한 tempToken',
						email: '인증 사용자 이메일',
						apiKey: '조직 UUID',
						role: '인증 사용자 역할',
						totpCode: '6자리 인증 앱 코드',
					},
				},
				backupEmail: {
					summary: '로그인 tempToken으로 백업 이메일 OTP를 전송합니다.',
					params: {
						tempToken: '/auth/login에서 반환된 tempToken',
						email: '인증 사용자 이메일',
						apiKey: '조직 UUID',
						role: '인증 사용자 역할',
					},
				},
				verifyEmailOtp: {
					summary: '이메일 OTP를 세션 토큰으로 교환합니다.',
					params: {
						email: '인증 사용자 이메일',
						apiKey: '조직 UUID',
						role: '인증 사용자 역할',
						emailOtp: '이메일로 전달된 6자리 코드',
					},
				},
				recoveryCodes: {
					summary: '인증 사용자의 복구 코드를 재생성합니다.',
					params: {
						sessionToken: '현재 세션 토큰',
						email: '인증 사용자 이메일',
						apiKey: '조직 UUID',
						role: '인증 사용자 역할',
						password: '현재 비밀번호',
					},
				},
				verifyRecovery: {
					summary: '복구 코드를 세션 토큰으로 교환합니다.',
					params: {
						email: '인증 사용자 이메일',
						apiKey: '조직 UUID',
						role: '인증 사용자 역할',
						recoveryCode: '이전에 발급된 8자리 복구 코드 중 하나',
					},
				},
			},
			environment: {
				baseUrl: '공개 API 원본 주소',
				apiKey: '오너 대시보드 API 키 (서버 측 저장 필수)',
				defaultRole: '인증 사용자에 할당할 역할/RBAC 값',
			},
		},
		console: {
			launching: 'AuthFlow™ Linux Console v1.0 실행 중 ...',
			connected: 'api.authflow.net 연결됨',
			sending: '> {method} {path} 전송 중',
			waiting: '> 응답 대기 중 ...',
			processExited: '[프로세스 종료 코드 {code}]',
			status: {
				defaultSuccess: 'HTTP/1.1 200 OK (예시)',
				signup: { success: 'HTTP/1.1 201 Created (예시)', alt409: '# 대안: 이메일+역할 중복 시 HTTP/1.1 409 Conflict' },
				login: { success: 'HTTP/1.1 200 OK (예시)', alt2fa: '# 대안: 2FA 활성화 시 requires2FA/tempToken 반환' },
				verifyEmail: { success: 'HTTP/1.1 200 OK (예시)', alt401: '# 대안: 검증 토큰이 만료/무효면 HTTP/1.1 401 Unauthorized' },
				validate: { success: 'HTTP/1.1 200 OK (예시)', alt401: '# 대안: 세션 토큰 만료/무효면 HTTP/1.1 401 Unauthorized' },
				forgotPassword: { success: 'HTTP/1.1 200 OK (열거 방지 응답)' },
				changePassword: { success: 'HTTP/1.1 200 OK (예시)', noJsonBody: '# 성공 시 JSON 본문 없음' },
			},
			failure: {
				signup: { status: 'HTTP/1.1 409 Conflict (예시)', extra: '# 실패 시나리오: 이메일+역할 중복' },
				login: { status: 'HTTP/1.1 400 Bad Request (예시)', extra: '# 실패 시나리오: 자격 증명 오류 또는 역할 불일치' },
				verifyEmail: { status: 'HTTP/1.1 401 Unauthorized (예시)', extra: '# 실패 시나리오: 만료된 인증 토큰' },
				validate: { status: 'HTTP/1.1 401 Unauthorized (예시)', extra: '# 실패 시나리오: 만료된 세션 토큰' },
				me: { status: 'HTTP/1.1 401 Unauthorized (예시)', extra: '# 실패 시나리오: sessionToken 누락/무효' },
				logout: { status: 'HTTP/1.1 401 Unauthorized (예시)', extra: '# 실패 시나리오: sessionToken 무효' },
				changePassword: { status: 'HTTP/1.1 401 Unauthorized (예시)', extra: '# 실패 시나리오: oldPassword 오류 또는 세션 만료' },
				resendVerifyEmail: { status: 'HTTP/1.1 401 Unauthorized (예시)', extra: '# 실패 시나리오: 만료된 foobar 토큰 또는 api_key 오류' },
				fooBar: { status: 'HTTP/1.1 400 Bad Request (예시)', extra: '# 실패 시나리오: identity 또는 api_key 누락' },
				forgotPassword: { status: 'HTTP/1.1 400 Bad Request (예시)', extra: '# 실패 시나리오: email 또는 api_key 누락' },
				resetPassword: { status: 'HTTP/1.1 401 Unauthorized (예시)', extra: '# 실패 시나리오: 만료된 reset 토큰' },
				default: { status: 'HTTP/1.1 400 Bad Request (예시)', extra: '# 실패 시나리오' },
			},
		},
		pageContent: {
			badge: 'Auth 제품 레퍼런스',
			title: 'AuthFlow™ API 문서',
			titleAccent: '조직 소유자용',
			description: '이 Get Started 문서는 조직 사용자 인증을 위한 공개 auth API를 설명합니다. AuthFlow™는 총 20개의 /auth 라우트를 제공합니다: 세션 7개, 비밀번호 관리 3개, 이메일 검증 2개, 2FA 8개.',
			downloadCollection: 'Insomnia 컬렉션 다운로드',
			createAccount: '소유자 계정 만들기',
			cloneStarterOnGitHub: 'Next.js 스타터 클론',
			starterInfoLabel: 'Next.js 스타터의 중요한 보안 정보',
			starterWarningTitle: '프로토타입 및 개념 증명 전용',
			starterWarningPrototype: 'authflow-nextjs-starter는 프로토타입과 개념 증명용 프런트엔드에만 사용해야 합니다. 프로덕션 브라우저 통합용이 아닙니다.',
			starterWarningSecret: 'AuthFlow API 키를 프로덕션 프런트엔드 코드, 브라우저에 노출되는 환경 변수, 정적 자산 또는 클라이언트 번들에 절대 넣지 마세요. 브라우저로 전달되는 모든 내용은 사용자와 공격자가 읽을 수 있습니다.',
			starterWarningProduction: '프로덕션에서는 신뢰할 수 있는 서버 측 백엔드 또는 AuthFlow ExpressJS 프록시를 통해 인증 요청을 보내고, API 키는 서버 측 환경 변수나 관리형 시크릿 저장소에 보관하세요.',
			apiKeyWarningTitle: 'AuthFlow API 키를 프로덕션 브라우저 코드에 절대 노출하지 마세요.',
			apiKeyWarningBody: 'API 키는 직접 제어하는 인프라에만 보관해야 합니다. JavaScript 번들, HTML, 공개 환경 변수, 모바일 웹 자산, 로그 또는 브라우저가 직접 보내는 네트워크 요청에 키를 포함하지 마세요. 키가 서버 측에 남도록 이 ExpressJS 프록시나 자체 백엔드를 사용하세요.',
			integrationRulesTitle: '통합 규칙',
			integrationRulesRules: [
				'조직 소유자는 AuthFlow™를 서버 렌더링/백엔드 코드에서만 호출해야 합니다. 브라우저 코드에는 비밀값을 저장하지 마세요.',
				'핵심 세션 관리 및 기타 라우트에는 조직 소유자 API 키가 필요합니다.',
				'fooBar 토큰은 짧은 수명의 anti-abuse 토큰이므로 가입/로그인 직전에 매번 새로 발급받으세요.',
				'로그인 응답이 requires2FA이면 문서화된 /auth/2fa 검증 흐름으로 세션 토큰을 교환해야 합니다.',
			],
			ownerAssetsTitle: '소유자 자산',
			ownerAssetsText: '구현 팀이 Insomnia로 바로 가져올 수 있는 정확한 컬렉션을 사용하세요.',
			ownerAssetsCollectionName: 'AuthFlow_Consumers.yaml',
			collectionIncludes: '컬렉션 포함 항목:',
			collectionItems: [
				'공개 /auth 세션 라우트 7개',
				'공개 /auth 비밀번호 관리 라우트 3개',
				'공개 /auth 이메일 검증 라우트 2개',
				'공개 /auth/2fa 라우트 8개',
				'API 키, role/RBAC, session token, TOTP, temp token, recovery code 흐름용 환경 변수',
			],
			checklistTitle: '구현 체크리스트',
			checklistSubtitle: 'AuthFlow™를 조직 인증에 연결하기 위한 권장 소유자 워크플로입니다.',
			configStep: '1. 서버 측 비밀값 설정',
			implementStep: '2. 서버 측 인증 구현',
			connectStep: '3. 프런트엔드 연결',
			connectStepSecurityNote: '브라우저 코드에는 소유자 API 키 같은 AuthFlow™ 비밀값을 절대 저장하지 마세요.',
			implementStepRules: ['/auth/fooBar 호출', '/auth/signUp 또는 /auth/login 호출', '세션 토큰 안전 저장', '/auth/validate, /auth/me, /auth/changePassword, /auth/logout를 보호 라우트에서 사용'],
			connectStepRules: ['로그인/회원가입 폼 제출', 'API가 requires2FA를 반환하면 2FA 프롬프트 처리', '앱 세션을 보안 쿠키에 저장', '세션 엔드포인트 응답으로 현재 사용자 로드'],
			sessionEndpointsTitle: '세션 엔드포인트',
			sessionEndpointsSubtitle: '이 7개 라우트는 백엔드 루트 엔드포인트의 authProduct.session과 매칭됩니다.',
			passwordMgmtTitle: '비밀번호 관리 엔드포인트',
			passwordMgmtSubtitle: '이 3개 라우트는 authProduct.passwordManagement와 매칭됩니다.',
			emailVerificationTitle: '이메일 검증 엔드포인트',
			emailVerificationSubtitle: '이 2개 라우트는 authProduct.emailVerification과 매칭됩니다.',
			twoFactorTitle: '2단계 인증 엔드포인트',
			twoFactorSubtitle: '이 8개 라우트는 authProduct.twoFactor와 매칭됩니다.',
			serviceExampleTitle: '서비스 예시',
			securityRequirementsTitle: '보안 요구사항',
			securityRequirements: ['AUTHFLOW_API_KEY는 서버 측에 암호화 보관하세요.', '앱 세션에는 HTTP-only 보안 쿠키를 우선 사용하세요.', '보호 데이터 응답 전에 AuthFlow™ 세션을 검증하세요.', '400, 401, 404, 409, 500 응답을 통합 로직에서 명시적으로 처리하세요.'],
			readyCtaTitle: '회사 인증 연동을 시작할 준비가 되었나요?',
			readyCtaDescription: '다운로드 가능한 컬렉션으로 시작하고, 비밀값을 안전하게 보관해 서비스 통합을 구현하세요. 필요하면 이 페이지의 어시스턴트를 활용하세요.',
			proxyTitlePrefix: 'ExpressJS ',
			proxyTitleSuffix: ' 프록시',
			proxyDescriptionPrefix: '원한다면 자체 ExpressJS 백엔드에서 AuthFlow 백엔드를 프록시할 수 있습니다. 이는 ',
			proxyDescriptionSuffix: ' 를 애플리케이션 스택에서 가장 안전하게 소비하는 방식 중 하나입니다.',
			proxyDetailsRoutes: '프록시는 AuthFlow /auth/* 및 /auth/2fa/* 라우트를 전달하고 조직 API 키를 서버 측에 유지해 브라우저 노출을 방지합니다.',
			proxyDetailsDeploy: '이 프록시는 Vercel 배포에 바로 대응하며 로컬 개발도 즉시 가능하고, 가입/로그인/비밀번호/2FA 검증 예시를 포함합니다.',
			proxyButton: 'GitHub에서 보기',
		},
	},
	comparisons: {
		hub: {
			breadcrumbRoot: '비교',
			breadcrumbCurrent: '인증 제품 비교',
			title: '인증 제품 비교',
			description: 'AuthFlow™가 가장 널리 쓰이는 인증 플랫폼과 어떻게 다른지 확인해보세요. 나란히 비교되는 기능 표를 통해 프로젝트에 맞는 인증 솔루션을 고를 수 있습니다.',
			card: {
				firebase: {
					title: 'Firebase vs. Auth0 vs. AuthFlow™',
					description: 'Google Firebase Authentication, Auth0의 엔터프라이즈 플랫폼, 그리고 개발자 중심의 AuthFlow™를 비교해보세요. 어떤 인증 솔루션이 현재 스택에 가장 잘 맞는지 빠르게 판단할 수 있습니다.',
				},
				supabase: {
					title: 'Supabase vs. Auth0 vs. AuthFlow™',
					description: 'Supabase의 오픈소스 인증, Auth0의 엔터프라이즈 기능, 그리고 가볍고 집중된 AuthFlow™ 인증 서비스를 비교해보세요. 이미 Supabase 생태계에 있다면 특히 유용합니다.',
				},
			},
			bullets: {
				core: '핵심 인증 기능과 보안',
				rbac: '2FA, RBAC 및 멀티 테넌시',
				supabaseModel: '오픈소스 vs. 관리형 vs. 집중형',
				pricing: '요금과 벤더 종속성',
				dx: '개발자 경험과 설정 복잡도',
			},
			viewComparison: '비교 보기',
		},
		labels: {
			fullySupported: '완전 지원',
			partial: '부분 지원 / 제한적',
			notSupported: '지원 안 함',
			feature: '기능',
			summary: '요약',
			startFree: 'AuthFlow™ 무료 시작',
			alsoSee: '함께 보기:',
			providers: {
				firebase: 'Firebase Auth',
				supabase: 'Supabase Auth',
				auth0: 'Auth0',
				authflow: 'AuthFlow™',
			},
			categories: { core: '핵심 인증', security: '보안', userOrg: '사용자 및 조직 관리', dx: '개발자 경험', pricing: '요금 및 유연성' },
		},
		features: {
			emailPassword: '이메일 및 비밀번호 인증',
			socialLogin: '소셜 로그인 (Google, GitHub 등)',
			magicLinks: '매직 링크 / 비밀번호리스',
			smsPhone: 'SMS / 전화번호 인증',
			anonymous: '익명 인증',
			jwt: 'JWT 토큰 관리',
			rs512: 'RS512 키 페어 서명',
			twofa: '이중 인증 (2FA)',
			totp: 'TOTP 인증 앱 (Google Auth, Authy)',
			backupCodes: '2FA 백업 코드',
			emailOtp: '이메일 OTP 기반 2FA',
			rateLimiting: '속도 제한',
			emailVerification: '이메일 인증',
			passwordReset: '비밀번호 재설정 / 비밀번호 찾기',
			passwordComplexity: '비밀번호 복잡도 강제',
			userDashboard: '사용자 관리 대시보드',
			rbac: '역할 기반 접근 제어 (RBAC)',
			multiTenancy: '멀티 테넌시 / 조직',
			perOrgApiKeys: '조직별 API 키',
			auditLogs: '감사 / 활동 로그',
			userBlocking: '사용자 차단 / 정지',
			simpleRest: '간단한 REST API (SDK 불필요)',
			officialSdks: '공식 클라이언트 SDK',
			customEmailTemplates: '사용자 지정 이메일 템플릿',
			webhooks: '웹훅 / 이벤트 콜백',
			selfHosted: '셀프 호스팅 옵션',
			openSource: '오픈소스',
			apiDocs: 'API 문서',
			integratedDb: '통합 데이터베이스 (PostgreSQL)',
			authOnly: '인증 전용 (데이터베이스 불필요)',
			freeTier: '무료 요금제 제공',
			flatRate: '예측 가능한 정액 요금',
			payPerMau: 'MAU 기반 과금 모델',
			lowLockIn: '낮은 벤더 종속성',
			lowSetup: '낮은 설정 복잡도',
			noEcosystemBuyIn: '생태계 종속 없이 사용 가능',
		},
		notes: {
			firebase2fa: 'Firebase에서 2FA를 사용하려면 Identity Platform 업그레이드가 필요합니다.',
			firebaseRest: 'Firebase는 SDK 중심이며, 순수 REST 사용 시 토큰 교환을 직접 처리해야 합니다.',
			firebaseLockIn: 'Firebase는 Google/Firebase 생태계와 강하게 결합됩니다.',
			supabaseRls: 'Supabase는 Postgres의 행 수준 보안(RLS) 정책을 사용합니다.',
			supabaseDb: 'Supabase Auth는 자체 Postgres 데이터베이스와 밀접하게 통합되어 있습니다.',
			supabaseLockIn: 'Supabase는 오픈소스라 종속성은 낮지만, 인증은 Postgres 스택과 긴밀히 연결됩니다.',
			supabaseAuthOnly: 'Supabase를 인증 전용으로 사용할 수는 있지만, 본질적으로 전체 백엔드 플랫폼으로 설계되었습니다.',
		},
		firebase: {
			breadcrumbCurrent: 'Firebase vs. Auth0 vs. AuthFlow™',
			title: 'Firebase vs. Auth0 vs. AuthFlow™',
			description: 'Google Firebase Authentication, Okta Auth0, 그리고 AuthFlow™를 나란히 비교해 애플리케이션에 맞는 인증 계층을 선택할 수 있도록 돕습니다.',
			summary: {
				firebaseTitle: 'Firebase Authentication',
				firebaseBody: '이미 Google/Firebase 생태계에 깊이 들어가 있는 팀에 적합합니다. 무료 구간은 넉넉하고 SDK 중심 통합은 편하지만, 고급 기능인 2FA는 Identity Platform이 필요하고 생태계 종속성이 큽니다.',
				auth0Title: 'Auth0',
				auth0Body: '세 제품 중 기능 범위가 가장 넓습니다. SAML, OIDC, 엔터프라이즈 SSO, 폭넓은 커스터마이징이 필요할 때 강력하지만, MAU가 늘수록 요금이 가파르게 증가합니다.',
				authflowTitle: 'AuthFlow™',
				authflowBody: '대규모 생태계에 묶이지 않으면서도 RS512 JWT, 2FA, RBAC 같은 강한 보안을 갖춘 이메일/비밀번호 인증이 필요할 때 적합합니다. 단순한 REST API, 예측 가능한 요금, 낮은 설정 복잡도를 제공합니다.',
			},
			alsoSee: 'Supabase vs. Auth0 vs. AuthFlow™',
		},
		supabase: {
			breadcrumbCurrent: 'Supabase vs. Auth0 vs. AuthFlow™',
			title: 'Supabase vs. Auth0 vs. AuthFlow™',
			description: 'Supabase Auth, Auth0, 그리고 AuthFlow™를 나란히 비교해 애플리케이션에 맞는 인증 계층을 선택할 수 있도록 돕습니다.',
			summary: {
				supabaseTitle: 'Supabase Auth',
				supabaseBody: '오픈소스이며 자체 호스팅 가능한 백엔드를 원하는 팀에 적합합니다. 소셜 로그인, 매직 링크, 깊은 Postgres 통합을 제공하며, 이미 Supabase 데이터베이스를 사용 중이라면 특히 잘 맞습니다.',
				auth0Title: 'Auth0',
				auth0Body: 'SAML, OIDC, 엔터프라이즈 SSO, 세밀한 커스터마이징까지 가장 폭넓은 기능 세트를 제공합니다. 규정 준수와 복잡한 요구사항이 많은 대규모 팀에 적합하지만, 월간 활성 사용자 수에 따라 비용이 빠르게 올라갑니다.',
				authflowTitle: 'AuthFlow™',
				authflowBody: '플랫폼 종속 없이 RS512 JWT, 2FA, RBAC를 포함한 안정적인 이메일/비밀번호 인증이 필요할 때 적합합니다. 단순한 REST API, 예측 가능한 정액 요금, 최소한의 설정으로 시작할 수 있습니다.',
			},
			alsoSee: 'Firebase vs. Auth0 vs. AuthFlow™',
		},
	},
	features: {
		title: 'AuthFlow™가 다른 이유',
		description: '우리는 JWT 기반 이메일/비밀번호 인증에 집중합니다. 이는 안전한 웹앱의 핵심입니다. 모든 것을 하려는 대신, 가장 중요한 한 가지를 탁월하게 수행합니다.',
		emailPassword: {
			title: '이메일/비밀번호 로그인',
			description: '단순하고 안전한 이메일/비밀번호 인증을 안정적으로 제공합니다. 불필요한 복잡함 없이, 사용자가 이해하는 로그인 경험만 제공합니다.',
		},
		jwtTokens: {
			title: 'JWT 토큰 관리',
			description: '세션을 위한 올바른 JWT 관리, 안전한 저장 및 자동 갱신을 제공합니다. API에 자연스럽게 통합되는 업계 표준 토큰입니다.',
		},
		developerApi: {
			title: '개발자 우선 API',
			description: '포괄적인 문서, SDK, 개발자 도구를 갖춘 REST API입니다. DevSecOps 워크플로를 위해 개발자가 만든 제품입니다.',
		},
	},
	testimonials: {
		title: '전 세계 개발자가 신뢰합니다',
		testimonial1: {
			text: 'AuthFlow™ 덕분에 개발 시간을 수개월 절약했습니다. 통합은 매끄러웠고 보안 기능은 엔터프라이즈 수준입니다.',
			author: 'Sarah Johnson',
			role: 'CTO, TechStart',
		},
		testimonial2: {
			text: '분석 대시보드가 사용자 행동에 대한 뛰어난 인사이트를 제공합니다. 우리가 써본 인증 솔루션 중 최고입니다.',
			author: 'Mike Rodriguez',
			role: 'Lead Developer, AppCorp',
		},
		testimonial3: {
			text: '매우 안정적이고 지원도 훌륭합니다. 사용자들이 부드러운 인증 경험을 좋아합니다.',
			author: 'Alex Liu',
			role: 'Product Manager, InnovateLab',
		},
	},
	signIn: {
		title: '다시 오신 것을 환영합니다',
		subtitle: '이메일/비밀번호 인증에 로그인하세요',
		card: {
			title: '조직 로그인',
			description: 'JWT 인증 대시보드에 접근하려면 조직 소유자 이메일을 입력하세요',
		},
		form: {
			email: { label: '이메일', placeholder: 'owner@yourorganization.com' },
			password: { label: '비밀번호', placeholder: '비밀번호를 입력하세요' },
			signIn: '로그인',
			signingIn: '로그인 중...',
			noAccount: { text: '조직이 없나요?', link: '만들기' },
		},
		errors: {
			emailRequired: '이메일은 필수입니다',
			failed: '로그인에 실패했습니다',
			unexpected: '예상치 못한 오류가 발생했습니다. 다시 시도해 주세요.',
		},
		success: { message: '로그인에 성공했습니다!' },
		agreement: {
			text: '로그인하면 다음에 동의한 것으로 간주됩니다:',
			terms: '이용약관',
			and: '및',
			privacy: '개인정보 처리방침',
		},
	},
	signUp: {
		title: '조직 생성',
		subtitle: '이메일/비밀번호 인증으로 조직을 시작하세요',
		card: {
			title: '조직 만들기',
			description: '이메일/비밀번호 인증과 JWT 토큰을 시작할 수 있도록 조직을 설정하세요',
		},
		form: {
			organizationName: { label: '조직 이름', placeholder: 'Your Organization' },
			organizationWebsite: { label: '조직 웹사이트', placeholder: 'yourorganization.com' },
			emailOwner: { label: '소유자 이메일', placeholder: 'owner@yourorganization.com' },
			password: { label: '비밀번호', placeholder: '강력한 비밀번호를 만드세요' },
			confirmPassword: { label: '비밀번호 확인', placeholder: '비밀번호를 확인하세요' },
			agreeToTerms: '이용약관 및 개인정보 처리방침에 동의합니다',
			acceptMarketing: '제품 업데이트 및 마케팅 이메일 받기',
			createOrganization: '조직 만들기',
			creatingOrganization: '조직 생성 중...',
			haveAccount: { text: '이미 계정이 있나요?', link: '로그인' },
		},
		errors: {
			organizationNameRequired: '조직 이름은 필수입니다',
			organizationWebsiteRequired: '조직 웹사이트는 필수입니다',
			emailRequired: '이메일은 필수입니다',
			passwordRequired: '비밀번호는 필수입니다',
			passwordsDoNotMatch: '비밀번호가 일치하지 않습니다',
			agreeToTermsRequired: '이용약관 및 개인정보 처리방침에 동의해야 합니다',
			failed: '조직 생성에 실패했습니다',
			unexpected: '예상치 못한 오류가 발생했습니다. 다시 시도해 주세요.',
		},
		success: { message: '조직이 성공적으로 생성되었습니다!' },
		trial: {
			description: '지금 바로 조직의 인증 관리를 시작하세요.',
			features: {
				emailPassword: '이메일/비밀번호 인증',
				jwtTokens: 'JWT 토큰 보안',
				simpleLogin: '간편 로그인',
			},
		},
	},
	common: {
		loading: '로딩 중...',
		error: '오류가 발생했습니다',
		success: '성공',
		cancel: '취소',
		save: '저장',
		delete: '삭제',
		edit: '수정',
		view: '보기',
		back: '뒤로',
		next: '다음',
		previous: '이전',
		language: '언어',
	},
	seo: {
		title: 'AuthFlow™ - 안전한 인증을 더 간단하게',
		description: '웹 애플리케이션을 위한 토큰 기반 인증. 쉬운 통합, 엔터프라이즈급 보안, 개발자 친화적인 API를 제공합니다. 지금 무료 체험을 시작하세요.',
		keywords: ['인증', 'auth', '보안', 'API', '토큰 기반 인증', 'JWT', '개발자 도구', '웹 보안', '사용자 관리'],
	},
	footer: {
		description: 'JWT 토큰 기반의 단순하고 신뢰할 수 있는 이메일/비밀번호 인증. 전 세계 개발자가 신뢰합니다.',
		product: '제품',
		resources: '리소스',
		company: '회사',
		apiReference: 'API 레퍼런스',
		about: '소개',
		support: '지원',
		privacyPolicy: '개인정보 처리방침',
		termsOfService: '이용약관',
		copyright: '© 2024 AuthFlow™. 모든 권리 보유.',
	},
	pricing: {
		title: 'AuthFlow™ 요금제 - 간단한 이메일/비밀번호 인증 비용',
		description: 'JWT 기반 이메일/비밀번호 인증을 위한 단순하고 투명한 요금제. 무료로 시작하고 성장에 따라 확장하세요. 숨겨진 비용이 없습니다.',
		keywords: ['인증 요금', '이메일 비밀번호 요금', 'JWT 요금', '간단한 인증 요금', '개발자 인증 요금', '신뢰 가능한 인증 비용', '보안 로그인 요금', '토큰 기반 인증 요금', '무료 인증 체험'],
		ogTitle: 'AuthFlow™ 요금제 - 간단한 이메일/비밀번호 인증 비용',
		ogDescription: '요구사항에 맞는 최적의 플랜을 선택하세요. 무료로 시작하고 JWT 기반 이메일/비밀번호 인증과 함께 성장하세요.',
		hero: {
			title: '단순하고 투명한',
			titleAccent: '인증 요금제',
			description: '인증 요구사항에 맞는 최적의 플랜을 선택하세요. JWT 세션 토큰 기반 이메일/비밀번호 인증으로 무료 시작 후 성장에 따라 확장하세요.',
		},
		breadcrumb: { product: '제품', pricing: '요금' },
		plans: {
			starter: {
				name: 'Starter',
				description: '소규모 프로젝트 및 이메일/비밀번호 인증 테스트에 적합',
				price: '$0',
				period: '/월',
				features: {
					users: '월간 활성 사용자 최대 10명',
					basicAuth: '기본 이메일/비밀번호 인증',
					support: '표준 지원',
				},
				cta: '무료로 시작',
			},
			pro: {
				name: 'Pro',
				description: '안정적인 이메일/비밀번호 인증이 필요한 성장 기업용',
				price: '$9.99',
				period: '첫 달, 이후 월 $19.99',
				badge: '가장 인기',
				features: {
					users: '월간 활성 사용자 무제한',
					advancedAuth: '고급 이메일/비밀번호 인증',
					support: '우선 지원',
				},
				cta: '무료 체험 시작',
				monthlyCta: '월간 구매',
				annualCta: '연간 구매',
			},
		},
		faq: {
			title: '자주 묻는 질문',
			subtitle: '이메일/비밀번호 인증 요금제와 플랜에 대해 알아야 할 모든 것.',
			questions: {
				mau: { question: '월간 활성 사용자(MAU) 기준은 무엇인가요?', answer: '월간 활성 사용자(MAU)는 한 달(달력 기준) 동안 최소 1회 인증한 고유 사용자입니다.' },
				changePlans: { question: '플랜은 언제든 변경 가능한가요?', answer: '예. 언제든 업그레이드/다운그레이드 가능하며 즉시 반영되고 요금은 일할 계산됩니다.' },
				freeTrial: { question: '무료 체험이 있나요?', answer: '예. 유료 플랜에는 3일 무료 체험이 포함되며 시작 시 신용카드가 필요 없습니다.' },
				paymentMethods: { question: '어떤 결제 수단을 지원하나요?', answer: '주요 신용카드와 Google Pay, Apple Pay를 지원합니다.' },
			},
		},
		cta: {
			title: '시작할 준비가 되었나요?',
			description: '신뢰 가능한 이메일/비밀번호 인증을 위해 AuthFlow™를 선택한 수천 명의 개발자와 함께하세요. 지금 무료 체험을 시작하세요.',
			startTrial: '무료 체험 시작',
			contactSales: '영업 문의',
		},
		footer: {
			description: 'JWT 토큰 기반의 단순하고 신뢰할 수 있는 이메일/비밀번호 인증. 전 세계 개발자가 신뢰합니다.',
			product: { title: '제품', features: '기능', pricing: '요금', apiReference: 'API 레퍼런스' },
			resources: { title: '리소스', gettingStarted: '시작하기', apiReference: 'API 레퍼런스', support: '지원' },
			company: { title: '회사', about: '소개', privacy: '개인정보 처리방침', terms: '이용약관' },
			copyright: '© 2024 AuthFlow™. 모든 권리 보유.',
		},
	},
	agent: {
		chatbot: {
			title: 'AuthFlow™ 도우미',
			inputPlaceholder: '/auth 또는 2FA 통합에 대해 물어보세요...',
			greeting: '조직 소유자가 AuthFlow™ auth-user 계약을 정확히 연결할 수 있도록 안내합니다. 소유자 API 키 설정, /auth 엔드포인트, 2FA 흐름, Insomnia 컬렉션, 프론트엔드-백엔드 경계, Settings 페이지 계정 삭제에 대해 물어보세요.',
			downloadIntro: '이 다운로드 카드를 사용해 팀이 즉시 가져올 수 있는 owner 컬렉션을 받으세요.',
			downloadTitle: 'Insomnia 컬렉션 다운로드',
			downloadButton: '다운로드',
			noAnswer: '에이전트에서 유효한 답변을 받지 못했습니다. 특정 엔드포인트, 2FA 흐름 또는 백엔드 통합 단계를 물어보세요.',
			error: '도우미 연결 중 오류가 발생했습니다. /auth 계약, 2FA 흐름 또는 Insomnia 컬렉션에 대해 다시 물어볼 수 있습니다.',
			toolNotFound: '도구를 찾을 수 없습니다',
		},
		tools: {
			verificationRecoveryDescription: '이메일 인증 및 비밀번호 복구 엔드포인트',
			accountSteps: ['1. https://www.authflow.net/sign-up 에서 조직 소유자로 가입', '2. 소유자 대시보드에서 조직 생성', '3. 대시보드에서 조직 API 키 복사', '4. 앱에서 사용할 auth 사용자 role 값 결정', '5. AuthFlow™ auth-user Insomnia 컬렉션 다운로드', '6. 컬렉션과 정확한 백엔드 계약을 통합 팀에 전달'],
			accountManagement: ['조직을 영구 삭제하려면 AuthFlow™ 대시보드 Settings 페이지로 이동하세요.', 'Delete Account 섹션에서 DELETE 를 입력해 되돌릴 수 없는 삭제를 확인하세요.'],
			reminder: '소유자 API 키는 회사 백엔드에만 보관해야 합니다.',
			environmentNotes: ['AUTHFLOW_API_KEY 는 서버 측에서만 사용하세요.', 'AUTHFLOW_DEFAULT_ROLE 은 선택 사항이지만 유용합니다.', '프론트엔드는 AuthFlow™ 직접 호출 대신 자체 백엔드 라우트를 호출해야 합니다.'],
			backendGuidance: ['/auth/signUp 또는 /auth/login 직전에 /auth/fooBar 를 가져오세요.', '공개 계약의 정확한 파라미터 이름을 사용하세요.', '/auth/login 이 requires2FA 를 반환하면 적절한 /auth/2fa 라우트로 계속 진행하세요.', '백엔드 라우트에서 사용자 검증/조회 후 앱 세션만 프론트엔드에 노출하세요.'],
			insomniaContains: ['공개 /auth 엔드포인트 12개 전체(verify-email, resend-verify-email, forgot-password, reset-password, deleteUser 포함)', '공개 /auth/2fa 엔드포인트 8개 전체', 'API 키, role, fooBar 토큰, tempToken, 세션 토큰, TOTP, 이메일 OTP, 복구 코드 흐름용 환경 변수'],
			troubleshoot: {
				solutions: {
					cors: '브라우저가 AuthFlow™ 를 직접 호출하면 먼저 중단하세요. 브라우저는 자체 백엔드를 호출하고 백엔드가 AuthFlow™ 를 호출해야 합니다.',
					'401_unauthorized': '/auth/fooBar 조회 또는 사용자 생성에 사용한 api_key, role, email 값이 정확히 일치하는지 확인하세요.',
					token_validation: '/auth/validate 에서는 sessionToken 과 email 쌍을 정확히 사용하고 tempToken 과 혼동하지 마세요.',
					connection_failed: 'AUTHFLOW_BASE_URL 이 https://api.authflow.net 인지와 백엔드 연결 가능 여부를 확인하세요.',
					api_key_invalid: '소유자 API 키는 af_ 로 시작하는 대시보드 키여야 합니다.',
					foobar_expired: 'fooBar 는 매우 짧게 유효합니다. 가입/로그인 직전에 새로 발급하세요.',
					verification_link: '이메일 검증 토큰이 유효해야 하며 /auth/verify-email 에 query 로 전달되어야 합니다.',
					password_reset: '먼저 /auth/forgot-password 호출 후, 이메일 토큰으로 /auth/reset-password 를 호출하세요.',
					two_factor_flow: '로그인이 requires2FA 를 반환하면 tempToken 은 /auth/2fa 라우트에서만 사용하세요.',
					organization_deletion: '영구 조직 삭제는 Settings > Delete Account 에서 DELETE 입력으로 진행합니다.',
					other: '요청을 공개 계약과 비교하세요: 파라미터명, HTTP 메서드, query/body/header 위치.',
				},
				commonIssues: ['프론트엔드에서 AuthFlow™ 직접 호출', '/auth/fooBar 또는 /auth/login 에서 api_key 누락/role 오류', '/auth/changePassword 의 oldPassword/newPassword 사용 오류', 'tempToken 과 sessionToken 혼동', '만료되었거나 유효하지 않은 인증 토큰', '/auth/forgot-password 없이 /auth/reset-password 호출', 'requires2FA 후 2FA 검증 교환 누락', 'Settings 흐름 밖에서 조직 삭제 시도'],
			},
		},
	},
} as const
